import BatHistory from './BatHistory'

export default BatHistory
